<!-- @format -->

<template>
  <div>
    <notifications group="plan" position="bottom center" />
    <div v-if="!newProposal">
      <div class="ui padded segment">
        <div class="ui segment">
          Filter:
          <a href="#" @click.prevent="getResults(-1)">
            <span
              :style="
                filterStatus == -1
                  ? 'font-weight: bold; color: black; cursor: text'
                  : ''
              "
            >
              <i class="ui icon circle "></i> Show All</span
            >
          </a>
          |
          <a href="#" @click.prevent="getResults(98)">
            <span
              :style="
                filterStatus == 98
                  ? 'font-weight: bold; color: black; cursor: text'
                  : ''
              "
            >
              <i class="ui icon circle " style="color: lightgrey"></i>
              Draft</span
            >
          </a>
          |
          <a href="#" @click.prevent="getResults(99)">
            <span
              :style="
                filterStatus == 99
                  ? 'font-weight: bold; color: black; cursor: text'
                  : ''
              "
            >
              <i class="ui icon circle " style="color: orange"></i> Awaiting
              Client Signature
            </span>
          </a>
          |
          <a
            href="#"
            @click.prevent="getResults(1)"
            :style="
              filterStatus == 1
                ? 'font-weight: bold; color: black; cursor: text'
                : ''
            "
          >
            <i class="ui icon circle " style="color: green"></i> Client
            Accepted</a
          >
          |
          <a
            href="#"
            @click.prevent="getResults(0)"
            :style="
              filterStatus == 0
                ? 'font-weight: bold; color: black; cursor: text'
                : ''
            "
          >
            <span>
              <i class="ui icon circle " style="color: red"></i> Client
              Rejected</span
            >
          </a>
        </div>
        <table v-if="proposals.length > 0" class="ui   table">
          <thead>
            <tr>
              <th>Created as at</th>
              <th>Status</th>
              <th>Plan</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tr v-for="(c, index) in proposals">
            <td>
              {{ c.createdAsAt }}
            </td>

            <td>
              <span v-if="c.status == 98">
                <span>
                  <i class="ui icon circle " style="color: lightgrey"></i>
                </span>
              </span>
              <span v-if="c.status == 99">
                <span>
                  <i class="ui icon circle " style="color: orange"></i>
                </span>
              </span>
              <span v-else-if="c.status == 1">
                <i class="ui icon circle " style="color: green"></i>
              </span>
              <span v-else-if="c.status == 0">
                <span>
                  <i class="ui icon circle " style="color: red"></i>
                </span>
              </span>
              <router-link :to="'/v2/plans/' + c.guid">
                {{ c.proposalName }}
              </router-link>
            </td>
            <td>
              <div data-tooltip="Opens the client investment plan in a new tab">
                <i class="ui external alternate icon"></i>
                <a :href="proposalUrl + '?c=' + c.guid" target="_blank"
                  >View Plan</a
                >
              </div>
            </td>
            <td>
              <sui-dropdown
                v-if="c.status == 98 || c.status == 99"
                text="Actions"
                class="ui label"
                tiny
                button
                pointing
              >
                <sui-dropdown-menu>
                  <sui-dropdown-item
                    v-if="c.status == 98"
                    @click.prevent="deletePlan(c.guid)"
                    >Delete</sui-dropdown-item
                  >
                  <sui-dropdown-item
                    v-if="c.status == 98"
                    @click.prevent="updatePlanStatus(c.id, 99)"
                    >Label as ['Awaiting Client Signature']</sui-dropdown-item
                  >
                  <sui-dropdown-item
                    v-if="c.status == 99"
                    @click.prevent="updatePlanStatus(c.id, 98)"
                    >Label as ['Draft']</sui-dropdown-item
                  >
                </sui-dropdown-menu>
              </sui-dropdown>
            </td>
          </tr>
        </table>

        <table v-else class="ui   table">
          <tr>
            <td>
              No plans
            </td>
          </tr>
        </table>
      </div>

      <span>
        <div class="ui primary button" @click.prevent="showNewProposal(true)">
          Create New Plan
        </div>
      </span>
    </div>
    <NewProposal v-if="newProposal" :clientId="clientId" />
    <div class="ui attached message" v-if="newProposal">
      <div @click.prevent="showNewProposal(false)" class="ui  button">
        Cancel
      </div>
    </div>
  </div>
</template>

<script>
import numeral from "numeral";
import moment from "moment";
// @ is an alias to /src
import {
  getClient,
  getProposalsV2,
  ProposalUrl,
  deleteProposalsV2,
  updateProposalStatusV2,
} from "@/gateway";
//import { GetClientProposalsV2 } from '../dtos';
import NewProposal from "@/components/NewProposal";

export default {
  name: "home",
  components: { NewProposal },
  computed: {
    partnerBackgroundUrl() {
      if (this.$store.state.partnerBackgroundUrl)
        return this.$store.state.partnerBackgroundUrl;
      else return "";
    },
    newPlansOfProposal() {
      let planss = [];
      console.log("newPlansOfProposal");
      for (var i = 0; i < this.proposals.length; i++) {
        console.log(i);
        if (this.proposals[i].addToPlan == true)
          planss.push(this.proposals[i].id);
      }
      return planss;
    },
  },
  data() {
    return {
      proposalUrl: "",
      newProposal: false,
      clientId: -1,
      proposals: [],
      results: null,
      filterStatus: -1,
    };
  },
  methods: {
    async updatePlanStatus(id, status) {
      const response = await updateProposalStatusV2({ id: id, status: status });
      if (response) {
        if (response.success) {
          this.$notify({
            group: "plan",
            title: "Plan status updated",
            position: "bottom right",
            type: "success",
          });
          this.getResults(this.filterStatus);
        } else {
          this.$notify({
            group: "plan",
            title: "Plan status not updated " + response.message,
            position: "bottom right",
            type: "error",
          });
        }
      }
    },

    async deletePlan(guid) {
      const response = await deleteProposalsV2({ guid: guid });
      if (response) {
        this.$notify({
          group: "plan",
          title: "Plan deleted",
          position: "bottom right",
          type: "success",
        });
        this.getResults(this.filterStatus);
      }
    },
    copyURL(copyLink, txt) {
      const el = document.createElement("textarea");
      el.value = copyLink;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    },
    updatePlanProposal(pl, event) {
      //  console.log("event", event);
      //  this.newPlansOfProposal.push(pl.id);
    },
    showNewProposal(val) {
      this.newProposal = val;
    },
    friendlyDate(arg, fmt) {
      if (fmt) return moment(arg, "YYYYMMDD").format(fmt);
      else return moment(arg).format("DD MMM YYYY HH:mm");
    },

    formatNr(val, fmt) {
      if (fmt) return numeral(val).format(fmt);
      else return numeral(val).format("0,0.0a");
    },

    async createProposal() {
      var goalIds = [];
      for (var i = 0; i < this.proposals.length; i++) {
        goalIds.push(this.proposals[i].id);
      }

      this.message = "Success";
    },
    async getResults(fltr) {
      this.loading = true;
      var response = await getClient({
        id: this.$route.params.id,
      });
      this.filterStatus = fltr;
      var response2 = await getProposalsV2({
        clientId: this.$route.params.id,
        partnerId: this.$store.state.partnerId,
        status: this.filterStatus,
      });

      this.results = response.result;
      this.proposals = response2.result;
      this.loading = false;

      // load client goals
    },
  },
  mounted: function() {
	  var domainName = "portfoliolink.co.za";
	  if (this.$store.state.appName.toLowerCase() == "questlink")
	  {
		  domainName = "questlink.app";
	  }
		
    this.proposalUrl = ProposalUrl.replace("portfoliolink.co.za",domainName);
    this.clientId = this.$route.params.id;
    this.getResults(-1);
  },
};
</script>
<style lang="css" scoped></style>
